export * from './_departamento-card/departamento-card.component'; 
export * from './_produtos-skel/produtos-skel.component';
